export class PngPaths {
  public static logo_ordas = "https://prestemos-assets.s3.amazonaws.com/png/ordas_logo.png";
  public static logo_sat = "https://prestemos-assets.s3.amazonaws.com/png/sat_logo.png";
  public static logo_mexico = "https://prestemos-assets.s3.amazonaws.com/png/logo_mexico.png";
  public static angular_logo = "https://prestemos-assets.s3.amazonaws.com/png/angular_icon.png";
  public static upload_proof = "https://prestemos-assets.s3.amazonaws.com/png/constancia.png";
  public static logo_inter = "https://prestemos-assets.s3.amazonaws.com/png/inter-logo.png";
  public static logo_eikos = "https://prestemos-assets.s3.amazonaws.com/png/eikos-logo.png";
  public static logo_marsh = "https://prestemos-assets.s3.amazonaws.com/png/marsh-logo.png";
  public static grinning_face = "https://nexu-rebranding-2025.s3.us-east-1.amazonaws.com/icons/png/grinning_emoji.png";
  public static pensive_face = "https://nexu-rebranding-2025.s3.us-east-1.amazonaws.com/icons/png/pensive_emoji.png";
  public static thinking_face = "https://nexu-rebranding-2025.s3.us-east-1.amazonaws.com/icons/png/thinking_emoji.png";
  public static logo_interesse = "https://prestemos-assets.s3.amazonaws.com/png/interesse-logo.png";
  public static logo_assurant = "https://prestemos-assets.s3.us-east-1.amazonaws.com/png/assurant_logo.png";
}
